// extracted by mini-css-extract-plugin
export var headerXL = "BlogPostThumbnail-module--headerXL--3jw-S";
export var headerL = "BlogPostThumbnail-module--headerL--2f-pZ";
export var headerM = "BlogPostThumbnail-module--headerM--AxhMy";
export var headerS = "BlogPostThumbnail-module--headerS--2UHGC";
export var headerXS = "BlogPostThumbnail-module--headerXS--3szcU";
export var blogHeaderXL = "BlogPostThumbnail-module--blogHeaderXL--19fyd";
export var blogHeaderL = "BlogPostThumbnail-module--blogHeaderL--WsQ6O";
export var blogHeaderM = "BlogPostThumbnail-module--blogHeaderM--1zRHY";
export var blogHeaderS = "BlogPostThumbnail-module--blogHeaderS--7mF0z";
export var blogHeaderXS = "BlogPostThumbnail-module--blogHeaderXS--30Gkd";
export var headerPreamble = "BlogPostThumbnail-module--headerPreamble--3SzHc";
export var preHeader = "BlogPostThumbnail-module--preHeader--1xXLj";
export var textNormal = "BlogPostThumbnail-module--textNormal--1m2SW";
export var textSmall = "BlogPostThumbnail-module--textSmall--S1np8";
export var textSmallAlternate = "BlogPostThumbnail-module--textSmallAlternate--2KA3g";
export var legend = "BlogPostThumbnail-module--legend--1ub--";
export var caption = "BlogPostThumbnail-module--caption--2PBLb";
export var gradientBackground = "BlogPostThumbnail-module--gradientBackground--1GDeN";
export var ellipsis = "BlogPostThumbnail-module--ellipsis--2ZXuC";
export var globalContainer = "BlogPostThumbnail-module--globalContainer--38Ndn";
export var maxWidth = "BlogPostThumbnail-module--maxWidth--N_F9X";
export var clipBottom = "BlogPostThumbnail-module--clipBottom--2thf0";
export var clipTopBottom = "BlogPostThumbnail-module--clipTopBottom--uq5U7";
export var thumbnail = "BlogPostThumbnail-module--thumbnail--39s1X";
export var mediaImage = "BlogPostThumbnail-module--mediaImage--2k3tP";
export var content = "BlogPostThumbnail-module--content--1itun";
export var title = "BlogPostThumbnail-module--title--1kyuY";
export var ch2 = "BlogPostThumbnail-module--ch2--2U4Gp";
export var ch2Container = "BlogPostThumbnail-module--ch2-container--11eFV";